import React from "react";
import styles from "./BuyButton.scss";
import { Button } from "../../../../components/Button/Button";

export interface IBuyButtonProps {
  onClick: any;
  isEnable: boolean;
  isLoading: boolean;
}

const BuyButton = (props: IBuyButtonProps): JSX.Element => {
  const { onClick, isEnable, isLoading } = props;
  return (
    <Button
      type="primary"
      className={!isEnable ? styles.disabledButton : styles.button}
      onClick={onClick}
      disabled={!isEnable}
      loading={isLoading}
    >
      <span className={styles.text}>{"Kupi kredite"}</span>
    </Button>
  );
};

export default BuyButton;



// WEBPACK FOOTER //
// ./src/containers/CreditsPage/CreditPackages/BuyButton/index.tsx